<aw-banner></aw-banner>
@if (isLoadingSubscriptions()) {
  <div class="-mx-auto container py-24">
    <aw-loading-animation
      [entityType]="EEntityType.ticketConfiguration"
      [relationType]="
        RelationType.loadingSubscriptionTickets
      "></aw-loading-animation>
  </div>
}
<div class="-m-1 flex w-full flex-row flex-wrap px-6 py-8">
  @for (ticket of subscriptions(); track $index; let index = $index) {
    <aw-ticket-tile
      class="w-6/12 p-1"
      (click)="equalize()"
      (onButtonClick)="configureSubscription($event)"
      [id]="'ticket-' + index"
      [ticket]="ticket | toTicketTile: ticket.name"></aw-ticket-tile>
  }
</div>
